import type { ContainerRecord, PrideStats } from "@retreat/core";

export function derivePrideStats(containers: ContainerRecord[]): PrideStats {
  return containers.reduce(
    (acc, c) => {
      if (c.containerType === 'sleep') {
        acc.sleepSeconds += c.actualDurationSeconds;
      } else if (c.containerType === 'meditation' && c.containerPosture === 'walking') {
        acc.walkingSeconds += c.actualDurationSeconds;
      } else if (c.containerType === 'meditation') {
        acc.meditationSeconds += c.actualDurationSeconds;
      }
      return acc;
    },
    { meditationSeconds: 0, walkingSeconds: 0, sleepSeconds: 0 } as PrideStats,
  );
}
